
export class SmsLoginRequest {
	public verificationGuid: string;
	public smsCode: string;
}
